import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';
import { container } from '@Container';
import { TYPES } from '@Types';
import { useParams } from 'react-router-dom';
import ArsenalArmyMake from '@Builder/myArsenal/army/make/ArsenalArmyMake';
import { MyArsenalAction } from '@Redux/actions';
import { Col, Row } from 'reactstrap';
import toast from 'react-hot-toast';
import arsenalArmySlice from '@Redux/reducers/arsenal/arsenal-army.slice';
import { ArsenalArmyActionState } from '@Stores/arsenal/ArsenalArmyState';
import ArsenalArmyShareComponent from '@Builder/myArsenal/army/make/share/arsenal-army-share.component';

const ArsenalArmiesPageMake: React.FC<ArsenalArmiesPageIndexProps> = (
  {
    load,
    action,
    request
  }
) => {
  const params = useParams();
  React.useEffect(() => {
    load(params.id!);
  }, []);

  let content = (<ArsenalArmyMake />);
  if (request.share)
    content = (<ArsenalArmyShareComponent />);

  return (
    <>
      <Row className="army_list">
        <Col xs={6} md={2} className="order-1 order-md-1 mt-1 text-center">
          <a href="#" onClick={() => action.toMake()}><i className="fas fa-clipboard-list fa-2x" /></a>
          <a href="#" onClick={() => action.toShare()} className="ms-1"><i className="fas fa-share-alt fa-2x" /></a>
        </Col>

        <Col xs={12} md={8} className="order-3 order-md-2 mt-1 d-flex flex-row">
          {/*{armyList.army?.logo &&
            <img src={armyList.army?.logo} alt={armyList.army?.name} height={75} className="float-start mt-2" />}
          <div className="ms-1 ms-md-3">
            <h3>{armyList.name} <span
              className="army-list-point small-text ms-2">{armyList.points} / {armyList.max} pts</span></h3>
            <small>{armyList.army?.name}{armyList.size != '' && (<> (<FormattedMessage
              id={armyList.size} />)</>)}</small>
          </div>
          */}
        </Col>

        <Col xs={6} md={2} className="order-2 order-md-3 mt-1 mb-1 text-center">
          <a href="#" onClick={() => action.toDelete()} className="ms-1"><i className="fas fa-trash fa-2x" /></a>
          <a href="#" onClick={() => action.toEdit()} className="ms-1"><i className="fas fa-edit fa-2x" /></a>
        </Col>
      </Row>

      {content}
    </>
  );
};

const mapStateToProps = (state: AppState) => ({
  request: {
    share: ArsenalArmyActionState.Share === state.arsenalArmy.action
  }
});

const mapDispatchToProps = (dispatch: Dispatch) => {

  const arsenalArmyAction = container.get<MyArsenalAction>(TYPES.Actions.MyArsenalAction);

  return {
    load: (id: string) => dispatch(arsenalArmyAction.fetchData({ entityId: id })),
    action: {
      toMake: () => dispatch(arsenalArmySlice.actions.cancel()),
      toShare: () => dispatch(arsenalArmySlice.actions.setRequest(ArsenalArmyActionState.Share)),
      toEdit: () => {
        toast.success('WIP, coming soon :)');
      },
      toDelete: () => {
        toast.success('WIP, coming soon :)');
      }
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ArsenalArmiesPageMake);

type ArsenalArmiesPageIndexProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>